// extracted by mini-css-extract-plugin
module.exports = {"editor":"draftEditorStyles_editor__1bSQU","editorShort":"draftEditorStyles_editorShort__2f5ah"};